import React from "react";
import NavBar from "../landingPage/header/navbar";
import Footer from "../landingPage/footer";
import TextConstants from "../../TextConstants";

function ComingSoon() {
  const { title } = TextConstants.COMING_SOON;
  return (
    <React.Fragment>
      <NavBar />
      <div className="coming-soon">
        <div className="cm-text">{title}</div>
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default ComingSoon;
